import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ContainerDimensions from 'react-container-dimensions';
import Spinner from '@fenderdigital/ui/Spinner';

const paddingPx = 16;
const getScaleFactorForWidth = viewportWidth => {
  const maxWidthBeforeShrinking = 580;
  const documentScale = Math.min(viewportWidth, maxWidthBeforeShrinking) / maxWidthBeforeShrinking;
  const containerWidth = viewportWidth * (1 / documentScale) - paddingPx * (1 / documentScale);
  return { documentScale, containerWidth };
};

const TablatureXML = ({ settings, tabXML }) => {
  const [isLoadingTab, setIsLoadingTab] = useState(false);
  const [TabModule, setTabModule] = useState({ Tab: null });

  if (!tabXML) {
    return null;
  }
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) {
    return <div className="futura-heavy pv2">Unable to render tablature.</div>;
  }

  if (!TabModule.Tab) {
    if (!isLoadingTab) {
      setIsLoadingTab(true);
      import(
        /* webpackChunkName: "@fenderdigital/tablature" */ '@fenderdigital/tablature'
      ).then(mod => setTabModule(mod));
    }
    return <Spinner strokeBaseColor="black" strokeColor="transparent" />;
  }

  return (
    <div className="tab-render overflow-x-scroll overflow-x-hidden-l overflow-y-hidden">
      <ContainerDimensions>
        {({ width }) => {
          const paddedWidth = width + paddingPx;
          const { containerWidth, documentScale } = getScaleFactorForWidth(paddedWidth);
          settings.documentScale = documentScale;
          return (
            <TabModule.Tab containerWidth={containerWidth} settings={settings} wrap xml={tabXML} />
          );
        }}
      </ContainerDimensions>
    </div>
  );
};

TablatureXML.propTypes = {
  settings: PropTypes.shape({}),
  tabXML: PropTypes.string,
};

TablatureXML.defaultProps = {
  settings: null,
  tabXML: null,
};

export default TablatureXML;
